import { Helmet } from 'react-helmet'
import MainHeader from '../../../components/MainHeader'
import MainFooter from '../../../components/MainFooter'

const FUNNELS = [
    {
        title: 'KMU / Webdesign',
        main: { label: 'KMU-Wachstum', path: '/funnel/kmu' },
        landings: [
            { label: 'Memmingen', path: '/landing/webdesign-memmingen' },
            { label: 'Unterallgäu', path: '/landing/webdesign-unterallgaeu' },
            { label: 'Allgäu', path: '/landing/webdesign-allgaeu' },
            { label: 'Kempten', path: '/landing/webdesign-kempten' },
        ],
    },
    {
        title: 'Veranstalter / Event',
        main: { label: 'Event-Boost', path: '/funnel/veranstalter' },
        landings: [
            { label: 'Memmingen', path: '/landing/event-memmingen' },
            { label: 'Unterallgäu', path: '/landing/event-unterallgaeu' },
            { label: 'Allgäu', path: '/landing/event-allgaeu' },
            { label: 'Kempten', path: '/landing/event-kempten' },
        ],
    },
    {
        title: 'Verein',
        main: { label: 'Verein-Komplett', path: '/funnel/verein' },
        landings: [
            { label: 'Memmingen', path: '/landing/verein-memmingen' },
            { label: 'Unterallgäu', path: '/landing/verein-unterallgaeu' },
            { label: 'Allgäu', path: '/landing/verein-allgaeu' },
            { label: 'Kempten', path: '/landing/verein-kempten' },
        ],
    },
    {
        title: 'Startup',
        main: { label: 'Web-Abo & Pakete', path: '/funnel/startup' },
        landings: [
            { label: 'Memmingen', path: '/landing/startup-memmingen' },
            { label: 'Unterallgäu', path: '/landing/startup-unterallgaeu' },
            { label: 'Allgäu', path: '/landing/startup-allgaeu' },
            { label: 'Kempten', path: '/landing/startup-kempten' },
        ],
    },
    {
        title: 'Foto & Video',
        main: { label: 'Fotografie & Videografie', path: '/funnel/foto' },
        landings: [
            { label: 'Memmingen', path: '/landing/photograph-memmingen' },
            { label: 'Unterallgäu', path: '/landing/photograph-unterallgaeu' },
            { label: 'Allgäu', path: '/landing/photograph-allgaeu' },
            { label: 'Kempten', path: '/landing/photograph-kempten' },
        ],
    },
]

export default function FunnelsOverview() {
    return (
        <div className="mainCon" id="mainCon--funnels-overview">

            <MainHeader selectedsite="" disableanimation={false} />

            <Helmet>
                <meta charSet="utf-8" />
                <title>Funnel-Übersicht | ToNetwork</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <section className="sec_next" id="sec_next--funnels-overview">
                <div className="sec_next_cont" id="sec_next--funnels-overview--cont">
                    <br />
                    <h2>Funnel-Übersicht</h2>
                    <br />
                    <p>Übersicht aller Conversion-Funnels und regionalen Landingpages.</p>
                    <br />

                    {FUNNELS.map((funnel) => (
                        <div key={funnel.main.path}>
                            <h3>{funnel.title}</h3>
                            <ul>
                                <li>
                                    <a href={funnel.main.path} className="sec_next_link">{funnel.main.label}</a>
                                    {' '}<span>({funnel.main.path})</span>
                                </li>
                            </ul>
                            <p>Regionale Landingpages:</p>
                            <ul>
                                {funnel.landings.map((landing) => (
                                    <li key={landing.path}>
                                        <a href={landing.path} className="sec_next_link">{landing.label}</a>
                                        {' '}<span>({landing.path})</span>
                                    </li>
                                ))}
                            </ul>
                            <br />
                        </div>
                    ))}
                </div>
            </section>

            <MainFooter />
        </div>
    )
}
